import BillBoardModel from "./billboard";
import PlaneModel from "./plane";
import SpriteModel from "./sprite";
const GeometryModels = {
  plane: PlaneModel,
  sprite: SpriteModel,
  billboard: BillBoardModel
};
export default GeometryModels;